<template lang="pug">
  include /mixins
  +b.t-story-video-card
    modal-trigger(
      name="UiStoryVideoModal",
      url="UiElements/UiStoryVideoModal",
      :classes="['storyVideoPopup']",
      :response="item.props.video.stream_response"
    )
      template(#default="{ open }")
        +e.video-wrapper(@click.prevent="open")
          +e.IMG.icon(:src="'/static/img/play.svg'")
          +e.image-wrapper.PICTURE
            template(v-if="item.props.video.img")
              source(
                type="image/webp",
                :srcset="item.props.video.img"
              )
              +e.image.IMG(
                :src="item.props.video.img"
              )
            +e.placeholder.IMG(
              v-else
              :src="'/static/img/academy_placeholder.png'"
            )
    +e.content
      +e.P.title {{ item.props.full_name }}
      +e.P.text {{ item.props.post }}
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>
